(function () {
  var ck_root = document.querySelector("[data-ck-upsell]");
  if (!ck_root) return;

  var ck_track = ck_root.querySelector("[data-ck-upsell-track]");
  var ck_prev = ck_root.querySelector("[data-ck-upsell-prev]");
  var ck_next = ck_root.querySelector("[data-ck-upsell-next]");
  if (!ck_track || !ck_prev || !ck_next) return;

  function ck_updateSingleState() {
    var cards = ck_root.querySelectorAll("[data-ck-upsell-card]");
    if (cards.length === 1) {
      ck_root.classList.add("ck-upsell--single");
    } else {
      ck_root.classList.remove("ck-upsell--single");
    }
  }
  ck_updateSingleState();

  function ck_step() {
    var ck_card = ck_track.querySelector(".ck-upsell__card");
    if (!ck_card) return 320;
    var ck_styles = window.getComputedStyle(ck_track);
    var ck_gap = parseFloat(ck_styles.columnGap || ck_styles.gap || "0") || 0;
    return ck_card.getBoundingClientRect().width + ck_gap;
  }

  function ck_updateArrows() {
    if (ck_root.classList.contains("ck-upsell--single")) {
      ck_prev.setAttribute("aria-disabled", "true");
      ck_prev.classList.add("is-disabled");
      ck_next.setAttribute("aria-disabled", "true");
      ck_next.classList.add("is-disabled");
      return;
    }
    var left = ck_track.scrollLeft;
    var maxScroll = ck_track.scrollWidth - ck_track.clientWidth;
    var threshold = 2;

    if (left <= threshold) {
      ck_prev.setAttribute("aria-disabled", "true");
      ck_prev.classList.add("is-disabled");
    } else {
      ck_prev.removeAttribute("aria-disabled");
      ck_prev.classList.remove("is-disabled");
    }
    if (maxScroll > threshold && left >= maxScroll - threshold) {
      ck_next.setAttribute("aria-disabled", "true");
      ck_next.classList.add("is-disabled");
    } else {
      ck_next.removeAttribute("aria-disabled");
      ck_next.classList.remove("is-disabled");
    }
  }

  ck_updateArrows();

  ck_prev.addEventListener("click", function () {
    if (this.classList.contains("is-disabled")) return;
    ck_track.scrollBy({ left: -ck_step(), behavior: "smooth" });
  });

  ck_next.addEventListener("click", function () {
    if (this.classList.contains("is-disabled")) return;
    ck_track.scrollBy({ left: ck_step(), behavior: "smooth" });
  });

  ck_track.addEventListener("scroll", function () {
    window.requestAnimationFrame(ck_updateArrows);
  });

  window.addEventListener("resize", function () {
    ck_updateArrows();
  });
})();

$(document).ready(function () {
  const $container = $("[data-ck-upsell]");

  if (!$container.length) return;

  function refreshCartDrawer() {
    if (
      window.theme &&
      window.theme.api &&
      typeof window.theme.api.cart === "object" &&
      typeof window.theme.api.cart.getCart === "function"
    ) {
      window.theme.api.cart.getCart().then(function (cart) {
        $(document).trigger("cart:updated", { cart: cart });
      });
      return;
    }
    $(document).trigger("cart:updated", { cart: null });
    var cartPopup = document.querySelector('[data-js-popup-name="cart"]');
    if (!cartPopup) return;
    var cartUrl =
      window.theme && window.theme.routes && window.theme.routes.cart_url
        ? window.theme.routes.cart_url
        : "/cart";
    fetch(cartUrl + "?view=popup", { headers: { Accept: "text/html" } })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var wrap = document.createElement("div");
        wrap.innerHTML = html;
        var newContent =
          wrap.querySelector(".popup-cart") ||
          wrap.querySelector("[data-popup-content]") ||
          wrap.firstElementChild;
        var currentContent =
          cartPopup.querySelector("[data-popup-content]") ||
          cartPopup.querySelector(".popup-cart") ||
          cartPopup;
        if (!newContent || !currentContent) return;
        var newHeader = newContent.querySelector(".popup-cart__header-content");
        var currentHeader = currentContent.querySelector(
          ".popup-cart__header-content",
        );
        if (newHeader && currentHeader)
          currentHeader.innerHTML = newHeader.innerHTML;
        var newItems = newContent.querySelector(".popup-cart__items");
        var currentItems = currentContent.querySelector(".popup-cart__items");
        if (newItems && currentItems)
          currentItems.innerHTML = newItems.innerHTML;
        var newFooter = newContent.querySelector(".popup-cart__footer");
        var currentFooter = currentContent.querySelector(".popup-cart__footer");
        if (newFooter && currentFooter)
          currentFooter.innerHTML = newFooter.innerHTML;
        var newEmpty = newContent.querySelector(".popup-cart__empty-content");
        if (newEmpty) {
          var itemsWrap = currentContent.querySelector(
            ".popup-cart__items-wrap",
          );
          if (itemsWrap) itemsWrap.classList.add("d-none");
          if (currentFooter) currentFooter.classList.add("d-none");
          var currentEmpty = currentContent.querySelector(
            ".popup-cart__empty-content",
          );
          if (currentEmpty) currentEmpty.classList.remove("d-none");
          else {
            var emptyWrap = document.createElement("div");
            emptyWrap.className = "popup-cart__empty-content";
            emptyWrap.innerHTML = newEmpty.innerHTML;
            currentContent.appendChild(emptyWrap);
          }
        } else {
          var wrapEl = currentContent.querySelector(".popup-cart__items-wrap");
          if (wrapEl) wrapEl.classList.remove("d-none");
          if (currentFooter) currentFooter.classList.remove("d-none");
          var emptyEl = currentContent.querySelector(
            ".popup-cart__empty-content",
          );
          if (emptyEl) emptyEl.classList.add("d-none");
        }
        if (window.ckPopupCartSetHeight) window.ckPopupCartSetHeight();
        document.dispatchEvent(
          new CustomEvent("loopPresetAddToCartSuccessEvent", { bubbles: true }),
        );
      })
      .catch(function () {});
  }

  $container.on("click", ".js-ck-add-cart", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const variantId = $btn.data("variant-id");
    const $card = $btn.closest("[data-ck-upsell-card]");

    if ($btn.hasClass("ck-loader")) return;

    $btn.addClass("ck-loader").prop("disabled", true);
    $card.addClass("is-selected");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: variantId,
        quantity: 1,
      },
      dataType: "json",
      success: function (item) {
        $card.removeClass("is-selected");
        $btn.removeClass("ck-loader");
        $btn.find(".ck-upsell__btn-arrow").hide();
        $btn.find(".ck-upsell__btn-check").show();
        $btn.addClass("is-added");

        document.dispatchEvent(
          new CustomEvent("ck:cart:product-added-from-upsell", {
            bubbles: true,
          }),
        );

        refreshCartDrawer();

        setTimeout(function () {
          $card.fadeOut(300, function () {
            $(this).remove();
            var remaining = $container.find("[data-ck-upsell-card]").length;
            if (remaining === 0) {
              $container.slideUp();
            } else if (remaining === 1) {
              $container.addClass("ck-upsell--single");
            }
          });
        }, 1000);
      },
      error: function (xhr, status, error) {
        console.error("Upsell add error:", error);
        $card.removeClass("is-selected");
        $btn.removeClass("ck-loader").prop("disabled", false);
      },
    });
  });
});
